import React, { useState, useEffect } from 'react';
import TableExample from './TableExample';

interface UsersProps {
  email: string;
  loggedIn: boolean;
  token: string;
  setLoggedIn: React.Dispatch<React.SetStateAction<boolean>>;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  baseUrl: string;
}

const Users: React.FC<UsersProps> = ({ email, loggedIn, token, setLoggedIn, setEmail, baseUrl }) => {
  const [userData, setUserData] = useState<{ Items: Array<{ email: string }> }>({ Items: [] });
  const [loading, setLoading] = useState<boolean>(true); // Loading state

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Set loading to true before fetching
      try {
        const response = await fetch(baseUrl + 'users', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'jwt-token': token,
          },
        });

        const data = await response.json();
        console.log(data);

        if (data.Items) {
          setUserData(data); // Update state with fetched data
        } else {
          console.error("Error: No items found");
        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    fetchData(); // Call the fetchData function
  }, [token]); // Dependency array: re-fetch only if token changes

 

  return (
    <div className={'mainContainer'}>
      <div className={'titleContainer'}>
        <div>Users</div>
      </div>
      <br />
      <div><TableExample userData={userData}/></div>
    </div>
  );
};

export default Users;
